export const NEWS_LIST_REQUEST = "NEWS_LIST_REQUEST";
export const NEWS_LIST_RECEIVE = "NEWS_LIST_RECEIVE";
export const NEWS_LIST_FAILURE = "NEWS_LIST_FAILURE";
export const RESET_NEWS_LIST = "RESET_NEWS_LIST";
export const NEWS_DETAILS_REQUEST = "NEWS_DETAILS_REQUEST";
export const NEWS_DETAILS_RECEIVE = "NEWS_DETAILS_RECEIVE";
export const NEWS_DETAILS_FAILURE = "NEWS_DETAILS_FAILURE";
export const RESET_NEWS_DETAILS = "RESET_NEWS_DETAILS";
